import { Controller } from 'stimulus';
import Vue from 'vue';
import guide from '../guide/Guide.vue';
import store from '../guide/store';

class BoxGuide extends Controller {
  connect() {
    const dataset = { ...this.element.dataset };

    dataset.boxSpecifications = JSON.parse(dataset.boxSpecifications);
    dataset.modals = JSON.parse(dataset.modals);
    dataset.debug = dataset.debug === 'true';

    Vue.mixin({
      data() {
        return {
          get i18n() {
            return JSON.parse(dataset.i18n);
          },
        };
      },
    });

    this.instance = new Vue({
      el: this.element,
      data: { dataset },
      store,
      components: { 'base-component': guide },
      template: '<base-component :dataset="dataset" />',
    });
  }
}

BoxGuide.targets = [
  //
];

export default BoxGuide;
